import { useSiteData } from "@/context/SiteDataContext";

export default function TrustBar() {
  const { data } = useSiteData();
  const confianzaBar = data.contentBlocks.home?.trust_bar ?? [];

  return (
    <section className="bg-background-50 border-b border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {confianzaBar.map((item) => (
            <div key={item.id} className="flex items-center gap-3">
              <span className="w-11 h-11 shrink-0 rounded-lg bg-accent-100 text-accent-600 flex items-center justify-center">
                <i className={`${item.icono} text-xl`} />
              </span>
              <div className="leading-tight">
                <p className="font-heading font-semibold text-foreground-900 text-sm whitespace-nowrap">
                  {item.titulo}
                </p>
                <p className="text-xs text-foreground-500">{item.descripcion}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}